var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-app',{attrs:{"id":"app"}},[_c('core-app-bar'),_c('core-drawer'),_c('core-view'),_c('snackbars'),_c('LightBox')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }